import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OPDSequenceMSt, OPDSequenceMStData } from '../../../interfaces/masters/opdsequence-mst';
import { OPDSequenceMStApi } from '../api/opdsequence-mst.api';

@Injectable()
export class OPDSequenceMStService extends OPDSequenceMStData{
    constructor(private api: OPDSequenceMStApi) {
      super();
    }
    
    list(url: string): Observable<OPDSequenceMSt[]> {
      return this.api.list(url);
    }    
    getById(url: string): Observable<any> {
      return this.api.list(url);
    } 
    create(url: string, data:any): Observable<any> {
      return this.api.add(url,data);
    }

    update(url: string, data:any): Observable<any> {
      return this.api.update(url,data);
    }   

    updateHealthCard(url: string, data:any): Observable<any> {
      return this.api.updateHealthCard(url,data);
    }   
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
}
 